export const CHECKING_STC_APPLICATION_STATUS_ROUTE =
  'sprawdz-czy-twoja-karta-do-tachografu-jest-gotowa';
